import { useMemo } from 'react';

export function useMarketplaceOptions(marketplaces = [], idProperty = 'id') {
  return useMemo(() => {
    return marketplaces.map((marketplace) => ({
      key: marketplace[idProperty],
      text: marketplace.name,
      value: marketplace[idProperty],
    }));
  }, [idProperty, marketplaces]);
}
